import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Generic placeholder for a product-scoped page that isn't built yet.
 * Used as a bridge during Wave 0 (layout split) before Wave 1 ports the
 * real SSL pages and later waves fill in DNS, Domain Expiry, etc.
 *
 * Intentionally minimal — the goal is to prove the ProductShell navigation
 * works end-to-end; visual polish and real content come in subsequent waves.
 */
export function ProductStub({ title, blurb, }) {
    return (_jsxs("div", { className: "space-y-3", children: [_jsx("h1", { className: "text-3xl font-semibold tracking-tight text-[var(--ink-900)]", style: { fontFamily: 'var(--f-display)' }, children: title }), _jsx("p", { className: "max-w-xl text-sm text-[var(--ink-500)]", children: blurb ??
                    'This product page is a Wave-0 scaffold. The real implementation lands in a later wave — see ONE_PORTAL_PRODUCT_NAV_PLAN.md for the port schedule.' })] }));
}
